import React from "react";
import { useState } from "react";
import { Row, Col, Card, Table, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import CardItem from "./CardItem";
import { useNavigate } from "react-router-dom";
import { Translate } from "../../Enums/Tranlate";
import Loader from "../../common/Loader";
import NoData from "../../common/NoData";
import Pagination from "../../common/Pagination/Pagination";
import RoleService from "../../../services/RoleService";

const Permission = () => {
	const [data, setData] = useState([]);
	const [hasData, setHasData] = useState(0);
	const [loading, setLoading] = useState(false);
	const [shouldUpdate, setShouldUpdate] = useState(false);
	const [search, setSearch] = useState("");
	const lang = useSelector((state) => state.auth?.lang);
	const roleService = new RoleService();
	const Auth = useSelector((state) => state.auth?.auth);
	const isExist = (data) => Auth?.admin?.admin_roles?.includes(data);
	const navigate = useNavigate();

	return (
		<div>
			<Card className="mb-3">
				<Card.Body className="d-flex justify-content-between p-3 align-items-center">
					<div className="input-group w-50">
						<input
							type="text"
							style={{
								borderRadius: "8px",
								color: "initial",
								padding: "18px 16px",
							}}
							className="form-control"
							placeholder={`${Translate[lang]?.search_by} ${Translate[lang]?.name}`}
							value={search}
							onChange={(e) => setSearch(e.target.value)}
						/>
						<div
							className="flaticon-381-search-2"
							style={{
								position: "absolute",
								zIndex: "1",
								right: lang === "en" && "16px",
								left: lang === "ar" && "16px",
								top: "50%",
								transform: "translate(0, -50%)",
							}}></div>
					</div>
					<div className="add-department">
						{
							<Button
								variant="primary"
								className="me-2 h-75"
								onClick={() => navigate("/roles/add_role")}>
								<i className="la la-plus mx-1"></i>
								{Translate[lang]?.add} {Translate[lang]?.role}
							</Button>
						}
					</div>
				</Card.Body>
			</Card>

			<Row>
				<Col lg={12}>
					<Card>
						<Card.Body
							className={`${hasData === 0 ? "text-center" : "table-style"} `}>
							{loading && (
								<div style={{ height: "400px" }}>
									<Loader />
								</div>
							)}

							{hasData === 1 && !loading && (
								<Table responsive>
									<thead>
										<tr>
											<th>
												<strong>{Translate[lang]?.name}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.action}</strong>
											</th>
										</tr>
									</thead>

									<tbody className="table-body">
										{data?.map((item, index) => {
											return (
												<CardItem
													index={index}
													key={index}
													item={item}
													setShouldUpdate={setShouldUpdate}
												/>
											);
										})}
									</tbody>
								</Table>
							)}
							{hasData === 0 && <NoData />}
							<Pagination
								setData={setData}
								service={roleService}
								shouldUpdate={shouldUpdate}
								setHasData={setHasData}
								setLoading={setLoading}
								search={search}
							/>
						</Card.Body>
					</Card>
				</Col>
			</Row>
		</div>
	);
};

export default Permission;
